import React from "react";
import { ParcoursStep } from "../../../modules/academy/parcours/models/ParcoursStep";

interface ParcoursStepCardProps {
  step: ParcoursStep;
  index: number;
  isCompleted: boolean;
  isCurrent: boolean;
  isGuest: boolean;
  onOpenStep: () => void;
  onMarkDone: () => void;
}

function typeLabel(type: ParcoursStep["type"]) {
  switch (type) {
    case "micro":
      return "Micro-cours";
    case "module":
      return "Module";
    case "quiz":
      return "Quiz";
    case "resource":
      return "Ressource";
    case "play":
      return "Play (mini-jeu)";
    case "assist":
      return "Assist";
    default:
      return "Etape";
  }
}

export function ParcoursStepCard({
  step,
  index,
  isCompleted,
  isCurrent,
  isGuest,
  onOpenStep,
  onMarkDone,
}: ParcoursStepCardProps) {
  return (
    <div className="rounded-2xl border shadow-sm p-4 bg-white dark:bg-slate-900 dark:border-slate-700 space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-[11px] px-2 py-0.5 rounded-full border bg-slate-50 text-slate-600 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-200">
            Etape {index + 1}
          </span>
          <p className="text-xs text-slate-500 dark:text-slate-400">{typeLabel(step.type)}</p>
        </div>
        {isCompleted && (
          <span className="text-[11px] px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-600 border border-emerald-500/30">
            Terminée
          </span>
        )}
        {!isCompleted && isCurrent && (
          <span className="text-[11px] px-2 py-0.5 rounded-full bg-blue-500/10 text-blue-700 border border-blue-500/30">
            En cours
          </span>
        )}
      </div>
      <h3 className="text-base font-semibold">{step.title || `${typeLabel(step.type)} (${step.ref})`}</h3>
      <div className="flex gap-2 flex-wrap">
        <button
          type="button"
          onClick={onOpenStep}
          className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
        >
          Ouvrir
        </button>
        {!isGuest && !isCompleted && (
          <button
            type="button"
            onClick={onMarkDone}
            className="px-3 py-1.5 rounded-lg border text-sm font-semibold bg-white dark:bg-slate-900 dark:border-slate-700"
          >
            Marquer comme terminé
          </button>
        )}
      </div>
    </div>
  );
}
